import {cloneDeep} from 'lodash';
import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import Utility from '../../util/utilityfunctions';
import {currentResource} from '../../util/utils';
import {QuickFilterTypes} from '../../util/uiconstants';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      storeIgua.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function getCommonReviewNotesFilters(state = initialState.commonRNHFilters, action) {
	switch (action.type) {
		case types.COMMON_SET_RNH_FILTERS: {
			let filterData = {...action.filters};
			filterData.isLoaded = true;
			return filterData;
		}
		case types.COMMON_SET_RNH_FILTER: {
			let value = action.value;
			if (!Utility.hasValue(value)) {
				// If filter is being disabled, set to empty array so it's removed from the URL.
				value = [];
			}
			let filters;
			filters = cloneDeep(state);

			if (action.filterKey && action.filterItemName) {
				if (!filters[action.filterKey]) {
					filters[action.filterKey] = {};
				}
				filters[action.filterKey][action.filterItemName] = value;
				filters.isLoaded = true;

				return {
					...state,
					...filters
				};
			}
			return state;
		}

		case types.COMMON_CLEAR_RNH_FILTERS: {
			let filterData = cloneDeep(state);

			if (action.filterKey) {
				filterData[action.filterKey] = {};
			}
			return filterData;
		}

		case types.COMMON_SET_RNH_FILTERS_BYKEY: {
			if (action.filters) {
				let result = {
					...state,
					[action.key]: {
						...state[action.key],
						...action.filters
					}
				};

				_.forEach(action.filters, (item, key) => {
					if (!Utility.hasValue(item)) {
						delete result[action.key][key];
					}
				});

				return result;
			} else {
				return {...state};
			}
		}

		default:
			return state;
	}
}
